// VitaFresh (16.10.2026): Gemeinsame Hilfen für alle, die den Warenkorb neu zeichnen (updateCartQty, refreshCart).
// vfKorbSection(): holt die Section helper-cart. Überkreuzen sich Abrufe (Mengenregler, Kühltasche, Formular einer
// Gerichtsseite, zweiter Tab), zeichnet nur die neueste Antwort; ältere liefern null (gemeinsamer Stand window.__vfKorbStand).
// vfKorbZeichnen(text): Formular, Kopfzähler und Summen aus dem HTML; liefert <cart-form>. Tippt gerade jemand im Mengenfeld
// (Timer läuft), wird nichts gezeichnet (null), damit das Feld nicht unter den Fingern ersetzt wird; die Übernahme der Menge
// zeichnet gleich darauf den neuesten Stand (oder holt ihn nach, wenn die Eingabe keine Zahl war).

if ( ! window.vfKorbSection ) {
	window.__vfKorbStand = 0;
	window.vfKorbSection = () => {
		const nr = ++window.__vfKorbStand;
		return fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => nr === window.__vfKorbStand ? text : null);
	};
	window.vfKorbZeichnen = (text) => {
		const cartItems = document.getElementById('AjaxCartForm');
		if ( cartItems.vfTippt ) {
			cartItems.vfVerpasst = true;
			return null;
		}
		cartItems.vfVerpasst = false;
		const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
		cartItems.innerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
		cartItems.ajaxifyCartItems();
		// VitaFresh (21.10.2026): Kopfzähler ohne Kühltasche (data-cart-count-anzeige, snippets/vf-korb-anzahl.liquid); data-cart-count bleibt die echte Zahl
		const vfAnzahl = cartItems.querySelector('[data-cart-count-anzeige]') || cartItems.querySelector('[data-cart-count]');
		document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
			elm.textContent = vfAnzahl.textContent.trim();
		});
		document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
		});
		document.getElementById('AjaxCartSubtotal').innerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
		if ( cartItems.vfHinweis ) { // Hinweis einer übergangenen Mengenänderung (updateCartQty)
			const form = cartItems.querySelector('form');
			if ( form ) form.prepend(cartItems.vfHinweis);
			cartItems.vfHinweis = null;
		}
		return cartItems;
	};
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					// VitaFresh (16.10.2026): Die Menge gilt, sobald das Tippen 500 ms ruht oder Enter kommt. Enter darf das Formular
					// nie absenden: der Browser «klickt» sonst den ersten Absende-Knopf des Formulars (auf der Warenkorbseite «Zur Kasse»).
					let timer = null;
					const uebernehmen = () => {
						clearTimeout(timer);
						timer = null;
						this.vfTippt = Math.max(0, (this.vfTippt || 0) - 1);
						const neu = parseInt(qty.value);
						if ( isNaN(neu) ) {
							// keine Zahl: nichts zu senden; ein währenddessen übergangenes Neuzeichnen (vfKorbZeichnen) wird nachgeholt
							if ( this.vfVerpasst && ! this.vfTippt && window.refreshCart ) window.refreshCart();
							return;
						}
						qty.blur();
						this.updateCartQty(item, neu);
					};
					qty.addEventListener('input', ()=>{
						if ( timer === null ) this.vfTippt = (this.vfTippt || 0) + 1;
						clearTimeout(timer);
						timer = setTimeout(uebernehmen, 500);
					});
					qty.addEventListener('keydown', (e)=>{
						if ( e.key !== 'Enter' ) return;
						e.preventDefault();
						if ( timer ) uebernehmen();
					});
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			// VitaFresh (16.10.2026): Zeilenschlüssel (item.key) statt Zeilennummer. Neue Artikel kommen bei Shopify oben hinein
			// (Kühltasche, «+» in den Empfehlungen, zweiter Tab), die Nummern im alten DOM verrutschen dann; der Schlüssel bleibt.
			// VitaFresh (21.10.2026): die Section kommt gleich mit der Antwort (sections), statt danach ein zweiter Abruf
			// ?section_id=helper-cart: eine Anfrage weniger, rund 0,4 s schneller. Fehlt sie (Fehler, ältere Antwort), wie bisher nachholen.
			const nr = ++window.__vfKorbStand;
			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty,
				sections: 'helper-cart',
				sections_url: window.location.pathname
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status >= 400 ) {
						// VitaFresh (16.10.2026): jeder Fehler bekommt einen Hinweis, nicht nur 422. 422 = Shopifys Grund (Bestand);
						// sonst (z. B. 400/404: die Zeile gibt es so nicht mehr, der Warenkorb hat sich inzwischen geändert) unser Satz.
						// Neu gezeichnet wird in jedem Fall, damit der Warenkorb wieder dem Server entspricht.
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						const grund = typeof response.description === 'string' ? response.description : response.message;
						alert.textContent = response.status == 422 && grund ? grund : 'Das hat nicht geklappt. Dein Warenkorb ist neu geladen, bitte versuche es nochmals.';
					}
					const mit = response.sections && response.sections['helper-cart'];
					// Überholt (refreshCart oder ein weiterer Klick dazwischen): wie bisher nachholen, damit der Stand nach dieser Änderung sicher gezeichnet wird.
					if ( typeof mit === 'string' && nr === window.__vfKorbStand ) return mit;
					return vfKorbSection();
				})
				.then(text => {
					// überholt oder jemand tippt: der Hinweis wartet am Formular und erscheint beim nächsten Neuzeichnen
					if ( text === null ) { if ( alert !== null ) document.getElementById('AjaxCartForm').vfHinweis = alert; return; }
					const cartItems = vfKorbZeichnen(text);
					if ( cartItems === null ) { if ( alert !== null ) document.getElementById('AjaxCartForm').vfHinweis = alert; return; }
					if ( alert !== null ) {
						this.form.prepend(alert);
					}
					cartItems.dispatchEvent(new Event('cart-updated'));
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart
// VitaFresh (16.10.2026): gibt ein Promise zurück (erfüllt, wenn Warenkorb und Zähler neu gezeichnet sind) und meldet am Ende
// «cart-updated» auf <cart-form> wie updateCartQty. Daran hängen die Klasse cart-section--empty der Warenkorbseite, der
// Liefertermin-Block, die Kühltasche und der Rabatt-Balken. Scheitert der Abruf, bleibt der Warenkorb wie er war (kein Ereignis).

if ( ! window.refreshCart ) {

	window.refreshCart = () => vfKorbSection()
		.then(text => {
			if ( text === null ) return; // überholt (neuerer Abruf unterwegs)
			const cartItems = vfKorbZeichnen(text);
			if ( cartItems === null ) return; // jemand tippt im Mengenfeld: die Übernahme der Menge zeichnet gleich den neuesten Stand
			// VitaFresh: refreshCart updated Header/Inhalt, öffnet Drawer nicht mehr automatisch
			/* drawer auto-open disabled */

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

			cartItems.dispatchEvent(new Event('cart-updated'));
		})
		.catch(e => {
			console.log(e);
		});

	// Zurück-Taste aus dem bfcache: die Seite kommt mit altem Stand zurück, der Warenkorb kann sich inzwischen geändert haben
	window.addEventListener('pageshow', e => {
		if ( e.persisted && document.getElementById('AjaxCartForm') ) window.refreshCart();
	});

}